import React from 'react';
import HandleComp from './HandleComp';
import { Steps, Breadcrumb, Icon, Spin, Button } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';
import queryString from 'query-string';

const { Step } = Steps;

export class CreateWizard extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        let typo = 1;
        if (params.typology != null) {typo = parseInt(params.typology, 10)}
        this.state = {
            user: this.props.token,
            hrs: [],
            categories: [],
            tipologies: [],
            companies: [],
            properties: [],
            detailsComp: ['0'],
            detailsOff: [],
            offId: 0,
            items: [],
            itemsOff: [],
            workflow: 0,
            compLoad: true,
            tipLoad: true,
            catLoad: true,
            propLoad: true,
            parentCompany: false,
            compId: params.id,
            typologyId: typo,
            sort: 1,
            parentCompanyDetail: null
        };

        this.changeStep = this.changeStep.bind(this);
        this.switchChange = this.switchChange.bind(this);

        document.title = "Polar - Create"

    }

    componentDidMount() {
        //companies
        fetch(
            `${SERVER_URL + 'api/company/home'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "companyname": '',
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 1,
                    "pageSizeOptions": null,
                    "CompanyNameStartWith": '',
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (this.state.compId != null) {
                    this.setState({
                        companies: res.data
                    })
                }
                else {
                    this.setState({ companies: res.data, compLoad: false });
                }
            })

        //tipologie
        fetch(
            `${SERVER_URL + 'api/translation/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "typeTip": "CompanyTypology",
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                this.setState({ tipologies: res.data }, this.setState({ tipLoad: false }));
            })

        //categorie
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": '',
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 999,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ categories: res.data }, this.setState({ catLoad: false }));
                } else {
                    this.setState({ categories: [] })
                }
            })

        //proprietà
        fetch(
            `${SERVER_URL + 'api/translation/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "typeTip": "Property",
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": '',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                } else {
                    this.setState({ properties: [] });
                }
            })

        if (this.state.compId != null) {
            fetch(
                `${SERVER_URL + 'api/company/' + this.state.compId + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                }
            ).then(response => response.json())
                .then(res => {
                    let sort = res.data.companySons.length + 1

                    this.setState({ parentCompanyDetail: res.data, parentCompany: true, compLoad: false, sort: sort });
                })
        }
    }

    changeStep = current => {
        // assegna lo stato del workflow
        this.setState({ workflow: current });
    };


    switchChange = e => {
        // assegna lo status
        this.setState({
            status: e.target.value,
        });
    };

    goBack() {
        return window.open("/", '_self');
    }

    render() {

        const { items } = this.state;

        //questo let mostra il componente solo se tutte le proprietà sono state scaricate
        let compHandle = !this.state.compLoad && !this.state.tipLoad && !this.state.catLoad ?
            this.state.detailsComp.map(i => (
                <HandleComp
                    user={this.state.user}
                    categories={this.state.categories}
                    companies={this.state.companies}
                    tipologies={this.state.tipologies}
                    properties={this.state.properties}
                    key={i}
                    i={i}
                    companiesCreated={this.state.detailsComp}
                    workFlow={this.state.workflow}
                    status={this.state.status}
                    parent={this.state.parentCompanyDetail}
                    parentId={this.state.compId}
                    typologyId={this.state.typologyId}
                    sort={this.state.sort}
                />
            )) : <Spin style={{ marginTop: "40px" }} />

        let parentName = this.state.parentCompany ? <h3>Parent: {this.state.parentCompanyDetail.name}</h3> : ''

        return (
            <Container fluid={true}>
                <Row className="specialBread">
                    <Col sm="12" style={{ display: 'inline-flex' }}>
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Create</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Col style={{ minHeight: '93vh' }} sm='12'>

                        <div className="wizardFields wizardContacts">

                            <div className="wizardBackground">

                                <Steps id="stepWorkflow" style={{color: 'gray'}} current={this.state.workflow} onChange={this.changeStep}>
                                    <Step title="Inserted" description="Data insert completed" icon={<Icon type="file-add" />} />
                                    <Step title="Under review" description="Editing required" icon={<Icon type="exception" />} />
                                    <Step title="To Verify" description="Waiting for approval" icon={<Icon type="solution" />} />
                                    <Step title="Approved" description="Ready to be published" icon={<Icon type="file-protect" />} />
                                    <Step title="Published" description="Content online" icon={<Icon type="file-done" />} />
                                </Steps>

                                <hr style={{ width: 'calc(100% - 100px)', marginLeft: '50px' }} />

                                <Row style={{margin: '0'}}>
                                    <Col sm="12" style={{ paddingLeft: '55px' }} className="createCompBoxPad">
                                        {parentName}
                                        <Row>
                                        {compHandle}
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Wizard/CreateWizard.js